/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'virtual-service-security-controller';
const prefix = `${moduleName}.${componentName}`;

export const securitySummaryTitle = `${prefix}.securitySummaryTitle`;
export const deprecationWarning = `${prefix}.deprecationWarning`;
export const sendFeedbackLink = `${prefix}.sendFeedbackLink`;
export const viewNewPageLink = `${prefix}.viewNewPageLink`;

export const ENGLISH = {
    [securitySummaryTitle]: 'Security Summary',
    [deprecationWarning]: 'This page will be deprecated soon. If there\'s something missing on the new Security page, please send us your feedback.',
    [sendFeedbackLink]: 'Send Feedback',
    [viewNewPageLink]: 'View New Page',
};
